<template>
  <confirm-dialog @confirmed="removeItem">
    <template #activator="{ on, attrs }">
      <slot name="activator" v-bind:attrs="attrs" v-bind:on="on">
        <v-btn small icon color="error" class="ml-2 pl-0 pr-0" v-bind="attrs" v-on="on">
          <v-icon>mdi-cancel</v-icon>
        </v-btn>
      </slot>
    </template>
    <template #title>
      {{ $t("remittances-.cancel") }}
    </template>
    {{ $t("remittances-.cancel_question") }}
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from "../components/ConfirmDialog";
import sales from "../../requests/sales";

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  methods: {
    removeItem: async function () {
      try {
        await sales.cancel(this.item.id);
        await this.$store.dispatch("notificator/success", this.$t("succeeded_operation"));
        this.$emit("cancelled");
      } catch (e) {
        await this.$store.dispatch("notificator/errorResponse", e);
      }
    },
  },
};
</script>
